<template>
  <div style="height:100%;">
    <vxe-toolbar ref="autoToolbar" custom></vxe-toolbar>
    <vxe-grid ref="autoTable" v-contextmenu:contextmenu :id='id' :columns='crrColumns' :data='data' max-height="auto" border show-overflow highlight-current-row highlight-hover-row highlight-current-column highlight-hover-column resizable column-key :custom-config={storage:{visible:true,resizable:true}} :radio-config={highlight:true} :checkbox-config={highlight:true,range:true} :header-cell-class-name="headerCellClassName" :cell-style="cellStyle" v-bind="$attrs" v-on="$listeners" @cell-click='cellClick' style='cursor: pointer;user-select: none;'>
      <template v-for="($scopedSlot,name) in $scopedSlots" v-slot:[name]='{row}'>
        <slot :name="name" :row='row'></slot>
      </template>
    </vxe-grid>
    <v-contextmenu theme='dark' ref="contextmenu">
      <v-contextmenu-item @click="copyclick">复制单元格</v-contextmenu-item>
      <v-contextmenu-item divider></v-contextmenu-item>
      <v-contextmenu-item @click="copyrowclick">复制高亮行</v-contextmenu-item>
      <v-contextmenu-item divider></v-contextmenu-item>
      <v-contextmenu-item @click="copycheckrowclick">复制多选行(通过鼠标在复选框的列内滑动选中或取消)</v-contextmenu-item>
    </v-contextmenu>
  </div>
</template>

<script>
// 修改了单独组件的单元格样式和复制通知
import Vue from 'vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VXETable, { size: 'mini' })
import './tableRenderer.js'
import Sortable from 'sortablejs'
import Contextmenu from 'v-contextmenu'
import 'v-contextmenu/dist/index.css'
Vue.use(Contextmenu)
import Clipboard from 'vue-clipboard2'
Vue.use(Clipboard)
export default {
	props: {
		id: {
			type: String,
			default: 'autoTable',
			desc: '标识',
		},
		columns: {
			type: Array,
			required: true,
			desc: '列配置',
		},
		data: {
			type: Array,
			required: true,
			desc: '数据',
		},
	},
	data() {
		return {
			sortSave: [], // 排序
			keyBoard: [], // 键盘
			isActivated:false, // 激活
			crr: [], // 首个
			start: [], // 范围左上
			end: [], // 范围右下
			line: '', // 行
		}
	},
	computed: {
		// 排序配置
		columnsSort() {
			let columnsSort = [...this.columns]
			return columnsSort.sort((crr, prev) => {
				if (crr.field && prev.field) {
					let crr_index = this.sortSave.indexOf(crr.field)
					let prev_index = this.sortSave.indexOf(prev.field)
					if (crr_index != -1 && prev_index != -1 && crr_index < prev_index) return -1
				}
				return 1
			})
		},
		// 显示配置
		crrColumns() {
			let crrColumns = [...this.columnsSort]
			crrColumns.forEach((element) => {
				element.cellRender = { name: '$Text', events: { onmousedown: this.onmousedown, onmouseover: this.onmouseover } }
				if (element.formatter) element.cellRender.formatter = element.formatter
				// 自定义元素重复绘制，猜测这里值会继承（测试成功），不可直接删除，避免下次重回配置丢失
				if (element.slots) {
					element.oldslots = element.slots
					delete element['slots']
				}
				if (element.oldslots && element.oldslots.default) {
					element.cellRender.slotsDefault = this.$scopedSlots[element.oldslots.default]
				}
			})
			return [{ type: 'seq', width: 50, fixed: 'left' }, { type: 'checkbox', width: 50, fixed: 'left' }, ...crrColumns]
		},
	},
	mounted() {
		this.$refs.autoTable.connect(this.$refs.autoToolbar) // 关联表格和工具栏
		this.getSort() // 初始化列排序
		this.columnDrop() // 初始化列置换
		this.initKeyboard() // 初始化按键
	},
	activated() {
		this.isActivated = true
	},
	deactivated() {
		this.isActivated = false
	},
	methods: {
		// 列头类名
		headerCellClassName({ column }) {
			if (!column.type) {
				return 'drop'
			}
		},
		// 单元格动态样式
		cellStyle({ rowIndex, columnIndex }) {
			if (this.judgment(rowIndex, columnIndex)) {
				return {
					backgroundColor: '#000',
					color: '#ffffff',
				}
			}
			if (this.judgments(rowIndex, columnIndex)) {
				return {
					backgroundColor: '#187',
					color: '#ffffff',
				}
			}
		},
		// 读取排序
		getSort() {
			let COLUMN_SORT = localStorage.getItem('COLUMN_SORT') || '{}'
			let crr_sort_obj = JSON.parse(COLUMN_SORT)[this.id] || []
			this.sortSave = crr_sort_obj
		},
		// 读取排序
		setSort(crr_sort_obj) {
			this.sortSave = crr_sort_obj
			let COLUMN_SORT = localStorage.getItem('COLUMN_SORT') || '{}'
			let sort_obj = JSON.parse(COLUMN_SORT)
			sort_obj[this.id] = this.sortSave
			localStorage.setItem('COLUMN_SORT', JSON.stringify(sort_obj))
		},
		// 初始化列置换
		columnDrop() {
			const $table = this.$refs.autoTable
			this.sortable2 = Sortable.create($table.$el.querySelector('.body--wrapper>.vxe-table--header .vxe-header--row'), {
				handle: '.vxe-header--column.drop',
				animation: 150,
				onEnd: ({ newIndex, oldIndex }) => {
					const { fullColumn, tableColumn } = $table.getTableColumn()
					// dom操作
					const oldColumnIndex = $table.getColumnIndex(tableColumn[oldIndex])
					const newColumnIndex = $table.getColumnIndex(tableColumn[newIndex])
					const currRow = fullColumn.splice(oldColumnIndex, 1)[0]
					fullColumn.splice(newColumnIndex, 0, currRow)
					// 保存操作
					let crr_sort_obj = fullColumn
						.filter((item) => item.property)
						.map((crr) => crr.property)
					this.setSort(crr_sort_obj)
					this.getSort()
				},
			})
		},
		// 范围开始选择
		onmousedown({ rowIndex, columnIndex }, { button }) {
			if (button != 0) return //0为鼠标左键
			this.keyBoard['select'] = true
			this.crr = [rowIndex, columnIndex]
			this.start = []
			this.end = []
			this.line = ''
			this.$refs.autoTable.clearCurrentRow()
		},
		// 范围滑动中
		onmouseover({ rowIndex, columnIndex }) {
			if (this.keyBoard['select'] && !this.start.length) {
				this.start = this.crr
			}
			if (this.keyBoard['select']) {
				this.end = [rowIndex, columnIndex]
			}
		},
		// 范围结束选择
		onmouseup() {
			if (!this.start.length) {
				this.line = this.crr[0]
			}
			this.keyBoard['select'] = false
		},
		// 初始化按键
		initKeyboard() {
			document.addEventListener('keydown', (e) => {
				this.keyBoard[e.key] = true
				if (this.keyBoard['Control'] && this.keyBoard['c']) {
					this.copyclick() //复制操作
				}
			})
			document.addEventListener('keyup', (e) => {
				this.keyBoard[e.key] = false
			})
			document.onmouseup = () => this.onmouseup() // 范围选择可能在表格之外放开
		},
		// 自动复制
		copyclick() {
			if (!this.start.length || !this.end.length) return this.copyboxclick()
			this.copyblokclick()
		},
		// 复制选中单元格
		copyboxclick() {
			if (!this.crr.length) return this.$notify.error('未选中！')
			let copyText = ''
			this.data.map((row, rowIndex) => {
				this.crrColumns.map((column, columnIndex) => {
					if (this.judgment(rowIndex, columnIndex)) {
						copyText = row[column.field]
					}
				})
			})
			if (!copyText) return
			this.$copyText(copyText)
		},
		// 复制选中单元格
		copyblokclick() {
			if (!this.start.length || !this.end.length) return this.$notify.error('未选中！')
			let copyText = ''
			this.data.map((row, rowIndex) => {
				let rowtext = ''
				this.crrColumns.map((column, columnIndex) => {
					if (this.judgments(rowIndex, columnIndex)) {
						if (rowtext) rowtext += '\t'
						rowtext += row[column.field]
					}
				})
				if (!rowtext) return
				if (copyText) copyText += '\n'
				copyText += rowtext
			})
			if (!copyText) return
			this.$copyText(copyText).then(() => {
				this.$notify.info('复制成功！')
			})
		},
		// 复制行
		copyrowclick() {
			let row = this.$refs.autoTable.getCurrentRecord()
			if (!row) return this.$notify.error('未选中！')
			let rowtext = ''
			this.columnsSort.map((column) => {
				if (rowtext) rowtext += '\t'
				rowtext += row[column.field]
			})
			if (!rowtext) return
			this.$copyText(rowtext).then(() => {
				this.$notify.info('复制成功！')
			})
		},
		// 复制行
		copycheckrowclick() {
			let selectRecords = this.$refs.autoTable.getCheckboxRecords()
			if (!selectRecords.length) return this.$notify.error('未选中！')
			let copyText = ''
			selectRecords.map((row) => {
				let rowtext = ''
				this.columnsSort.map((column) => {
					if (rowtext) rowtext += '\t'
					rowtext += row[column.field]
				})
				if (!rowtext) return
				if (copyText) copyText += '\n'
				copyText += rowtext
			})
			if (!copyText) return
			this.$copyText(copyText).then(() => {
				this.$notify.info('复制成功！')
			})
		},
		// 双击行
		cellClick({ row }) {
			this.$refs.autoTable.clearCheckboxRow()
			this.$refs.autoTable.setCheckboxRow([row], true)
		},
		// util
		judgment(rowIndex, columnIndex) {
			if (this.crr.length) {
				if (this.crr[0] == rowIndex && this.crr[1] == columnIndex) {
					return true
				}
			}
		},
		judgments(rowIndex, columnIndex) {
			if (this.start.length && this.end.length) {
				if ((this.start[0] <= rowIndex && rowIndex <= this.end[0]) || (this.end[0] <= rowIndex && rowIndex <= this.start[0])) {
					if ((this.start[1] <= columnIndex && columnIndex <= this.end[1]) || (this.end[1] <= columnIndex && columnIndex <= this.start[1])) {
						return true
					}
				}
			}
		},
	},
}
</script>

<style>
.vxe-toolbar {
    background: transparent;
}
.celltext {
	position: relative;
	width: calc(100% + 20px);
	left: -10px;
	padding-left: 10px;
	padding-right: 10px;
	line-height: 36px;
	height: 36px;
}
.vxe-header--row .vxe-header--column.sortable-ghost,
.vxe-header--row .vxe-header--column.sortable-chosen {
	background-color: #dfecfb;
}
</style>
